import {LandingPage} from './pages/Landing';

const App:React.FC =()=> {
  return(
    <div>   
      <LandingPage/>
    </div>
  )
}
export default App;
